import { useEffect } from 'react';
import { Platform, StatusBar, View, useWindowDimensions } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { useAuth } from '@/stores/authStore';
import { LoginScreen } from '@/screens/auth/LoginScreen';
import { SplashScreen } from '@/screens/auth/SplashScreen';
import { AppRouter } from '@/navigation/AppRouter';
import { EnvBanner } from '@/components/layout/EnvBanner';
import { colors } from '@/theme/tokens';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  const { height } = useWindowDimensions();
  const initialized = useAuth((s) => s.initialized);
  const firebaseUser = useAuth((s) => s.firebaseUser);
  const perfil = useAuth((s) => s.perfil);
  const init = useAuth((s) => s.init);

  useEffect(() => {
    const unsub = init();
    return unsub;
  }, [init]);

  // En web fijamos altura del viewport para que los hijos con flex:1 se expandan correctamente.
  const rootStyle = Platform.OS === 'web' ? ({ height } as const) : ({ flex: 1 } as const);

  return (
    <GestureHandlerRootView style={rootStyle as any}>
      <SafeAreaProvider>
        <QueryClientProvider client={queryClient}>
          <StatusBar barStyle="dark-content" backgroundColor={colors.crema[50]} />
          <View style={[rootStyle as any, { backgroundColor: colors.crema[50], overflow: 'hidden' }]}>
            <EnvBanner />
            <View style={{ flex: 1, minHeight: 0 }}>
              {!initialized ? (
                <SplashScreen />
              ) : !firebaseUser || !perfil ? (
                <LoginScreen />
              ) : (
                <AppRouter />
              )}
            </View>
          </View>
        </QueryClientProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}
